import { useQuery } from "@tanstack/react-query";
import { create, windowScheduler } from "@yornaath/batshit";
import keyBy from "lodash/keyBy";
import { AIAgent } from "@graylog/enterprise-api";
import generateId from "logic/generateId";
import { TOKEN_USAGE_QUERY_KEY } from "../AgentWorkflows/Constants";
const filterValues = (values) => (values == null ? void 0 : values.length) ? values : null;
const normalizedParams = ({ timerange, type, provider, model, runId }) => ({
  timerange: timerange != null ? timerange : null,
  type: filterValues(type),
  provider: filterValues(provider),
  model: filterValues(model),
  runId: filterValues(runId)
});
const buildRequest = ({ timerange, type, provider, model, runId }, frontendId) => ({
  frontend_id: frontendId,
  timerange,
  type,
  provider,
  model,
  run_id: runId
});
const buildRequests = (params) => {
  const frontendId = generateId();
  return params.map((param, index) => buildRequest(param, `${frontendId}-${index}`));
};
const summaryFor = (responsesByFrontendId, request) => {
  const response = responsesByFrontendId[request.frontend_id];
  if (!response) {
    throw new Error("Token usage response is missing a summary for the request.");
  }
  return {
    input_tokens: response.input_tokens,
    output_tokens: response.output_tokens,
    total_tokens: response.total_tokens
  };
};
const tokenUsageBatcher = create({
  fetcher: (requestBatches) => {
    const requests = requestBatches.flat();
    const generatedRequests = requests;
    return AIAgent.tokenUsage(generatedRequests);
  },
  resolver: (responses, requests) => {
    const responsesByFrontendId = keyBy(responses, "frontend_id");
    return requests.map((request) => summaryFor(responsesByFrontendId, request));
  },
  scheduler: windowScheduler(10)
});
const fetchTokenUsage = (params) => tokenUsageBatcher.fetch(buildRequests(params));
const useTokenUsage = (params) => {
  const usageParams = params.map(normalizedParams);
  return useQuery({
    queryKey: [...TOKEN_USAGE_QUERY_KEY, usageParams],
    queryFn: () => fetchTokenUsage(usageParams),
    enabled: usageParams.length > 0,
    staleTime: 6e4
  });
};
export default useTokenUsage;
